import { environment } from 'src/environments/environment';

export const SERVER_API_URL = environment.SERVER_API_URL;
export const REGIONS = ['EU','LN'];